import React, {Component} from "react";
import axios from "axios";
//import {browserHistory} from 'react-router';
import {DragDropContext} from "react-dnd";
import {connect} from 'react-redux';
import HTML5Backend from "react-dnd-html5-backend";
import joint from "jointjs";
import {Button, Card, Col, Collapse, Menu, message, notification, Row, Drawer} from 'antd';
import ProjectMenu from "./WorkbenchMenu/ProjectMenu";
import ProjectPlayground from "./ProjectCanvas/ProjectPlayground";
import DataSetDetail from "./ModuleDetail/DataSetDetail";
import ModelDetail from "./ModuleDetail/ModelDetail";
import AlgorithmDetail from "./ModuleDetail/AlgorithmDetail";
import ContextMenu from "./WorkbenchMenu/ContextMenu";
import {getData} from "../../../UserService/Common/utils";
import {updateProps} from "../ProjectTable/projectTableData";
import $ from "jquery";
import SaveModal from "./PromptModal/SaveModal";
import ProjectPanelTooltip from "./ProjectPanelTooltip";

const SubMenu = Menu.SubMenu;
const Panel = Collapse.Panel;
const ButtonGroup = Button.Group;

let clone = null;
let origin = null;
let originType = null;

class ProjectPanel extends Component {

  state = {
    // used for track mouse click
    selfOffset: "",
    clickX: 0,
    clickY: 0,

    // used for message count
    messageVisible: false,

    // control right click menu visible
    contextMenuVisible: false,
    contextMenuClickId: "",

    // algorithm tooltip
    algorithmRunningStatusVisible: false,
    algorithmRunningStatusOffset: {
      x: 0,
      y: 0
    },
    algorithmRunningStatusSelectId: "",

    // save modal
    saveModalVisible: false,
    saveItem: "",

    // main data structure of graph
    dataSetMap: {},
    algorithmMap: {},
    modelMap: {},

    drawerVisible: false,
  };

  constructor() {
    super();

    // init
    this.addPaperEventListeners = this.addPaperEventListeners.bind(this);
    this.initializeParameters = this.initializeParameters.bind(this);
    this.onLoadClick = this.onLoadClick.bind(this);
    this.loadModule = this.loadModule.bind(this);
    this.loadDataSet = this.loadDataSet.bind(this);
    this.loadAlgorithm = this.loadAlgorithm.bind(this);
    this.loadModel = this.loadModel.bind(this);


    // joint graph
    this.checkConnection = this.checkConnection.bind(this);
    this.addCell = this.addCell.bind(this);


    // calculate mouse click position.
    this.getClientOffset = this.getClientOffset.bind(this);
    this.updateClientOffset = this.updateClientOffset.bind(this);


    // handle button click event.
    this.onSaveClick = this.onSaveClick.bind(this);
    this.saveAlgorithmModule = this.saveAlgorithmModule.bind(this);
    this.saveDataSetModule = this.saveDataSetModule.bind(this);
    this.saveModelModule = this.saveModelModule.bind(this);
    this.saveProjectGraphFile = this.saveProjectGraphFile.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
    this.onCompileClick = this.onCompileClick.bind(this);
    this.onRunClick = this.onRunClick.bind(this);
    this.saveRunStatus = this.saveRunStatus.bind(this);
    this.cleanProject = this.cleanProject.bind(this);
    this.promiseSerial = this.promiseSerial.bind(this);
    this.onBackClick = this.onBackClick.bind(this);


    // render helper
    this.renderDetails = this.renderDetails.bind(this);


    // update main data structure
    this.updateDataSetMap = this.updateDataSetMap.bind(this);
    this.updateModelMap = this.updateModelMap.bind(this);
    this.updateAlgorithmMap = this.updateAlgorithmMap.bind(this);
    this.updateAlgorithmBasic = this.updateAlgorithmBasic.bind(this);
    this.updateAlgorithmParam = this.updateAlgorithmParam.bind(this);


    // convert param type to code
    this.getInputParamTypeCode = this.getInputParamTypeCode.bind(this);
    this.getOutputParamTypeCode = this.getOutputParamTypeCode.bind(this);


    // context menu
    this.deleteElement = this.deleteElement.bind(this);
    this.copyElement = this.copyElement.bind(this);
    this.cutElement = this.cutElement.bind(this);
    this.pasteElement = this.pasteElement.bind(this);
    this.saveElement = this.saveElement.bind(this);
    this.clearSaveElement = this.clearSaveElement.bind(this);
    this.runElement = this.runElement.bind(this);
    this.getOutput = this.getOutput.bind(this);

    this.onDrawerClose = this.onDrawerClose.bind(this);
  }

  componentDidMount() {
    this.graph = new joint.dia.Graph();
    const me = this;
    this.paper = new joint.dia.Paper({
      el: this.playground.decoratedComponentInstance.view,
      width: this.playground.clientWidth,
      height: 7000,
      gridSize: 10,
      drawGrid: true,
      background: {
        color: "rgba(0,0,0,.01)"
      },
      model: this.graph,
      validateConnection: function (cellViewS, magnetS, cellViewT, magnetT, end, linkView) {
        if (magnetS && magnetT && cellViewS && cellViewT) { //me.state.algorithmMap[cellViewT.model.attributes.id]) {

          if (magnetS && magnetS.getAttribute('port-group') === 'in') return false;

          if (cellViewS === cellViewT) return false;

          let target = me.graph.getCell(cellViewT.model.attributes.id);
          let sourceModuleId = cellViewS.model.attributes.id;
          let outPortNum = magnetS.getAttribute("port").substr(4);
          let outPortParamType = null;

          if (me.state.algorithmMap[sourceModuleId]) {
            outPortParamType = me.state.algorithmMap[sourceModuleId].outputParams[outPortNum].type.split("_")[0];
          } else if (me.state.dataSetMap[sourceModuleId]) {
            outPortParamType = "DATASET";
          } else if (me.state.modelMap[sourceModuleId]) {
            outPortParamType = "MODEL";
          }

          let targetModuleId = cellViewT.model.attributes.id;
          let inPortNum = magnetT.getAttribute("port").substr(4);
          let inPortParamType = me.state.algorithmMap[targetModuleId].inputParams[inPortNum].type.split("_")[0];
          let ans = me.checkConnection(
            me.state.algorithmMap[cellViewT.model.attributes.id].inputParams.map(input => input.type),
            me.graph.getConnectedLinks(target, {inbound: true}).map(t => {
              if (me.state.algorithmMap[t.attributes.source.id])
                return me.state.algorithmMap[t.attributes.source.id].outputParams[t.attributes.source.port.substr(4)].type;
              else if (me.state.dataSetMap[t.attributes.source.id])
                return "DATASET";
              else
                return "MODEL";
            }),
            outPortParamType);

          ans = ans && (inPortParamType === outPortParamType);
          if (ans === false && !me.state.messageVisible) {
            me.setState({
              messageVisible: true
            });
            message.config({
              top: 16,
              duration: 3
            });
            message.error("无法连接", () => {
              me.setState({
                messageVisible: false
              })
            });

          }
          return ans && magnetT && magnetT.getAttribute('port-group') === 'in';
        }
      },
      validateMagnet: function (cellView, magnet) {
        return magnet.getAttribute('magnet') !== 'passive';
      },
      // TODO: there is a problem to enable snap links.
      // markAvailable: true
      // snapLinks: {
      //   radius: 10
      // }
    });

    this.addPaperEventListeners();
    this.initializeParameters();

    if (this.props.projectId !== "" &&
        this.props.projectId !== undefined &&
        this.props.projectId !== null) {
      this.onLoadClick();
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      selectId: "",
      selectType: ""
    });
  }


  render() {
    return (
      <Card title="项目页面" bodyStyle={{
        padding: "4px"
      }}>
        <Row type="flex" justify="start">
          {/*, minWidth: 1298}}>*/}
          <Col md={12} lg={10} xl={6} xxl={6} style={{
            // marginRight: 4,
            // border: "1px solid rgba(0,0,0,.1)",
            height: 700,
            overflowY: "auto"
          }}>
            <ProjectMenu/>
          </Col>

          <Col md={12} lg={14} xl={18} xxl={18} style={{
            height: 700,
            overflowY: "auto",
            // marginRight: 4,
            position: "relative",
            // borderLeft: "1px solid rgba(0,0,0,.1)",
            // borderRight: "1px solid rgba(0,0,0,.1)"
          }}>
            <ProjectPlayground
              addCell={this.addCell}
              selfOffset={this.state.selfOffset}
              ref={ref => this.playground = ref}
              getClientOffset={this.getClientOffset}
              updateClientOffset={this.updateClientOffset}
              updateDataSetMap={this.updateDataSetMap}
              updateModelMap={this.updateModelMap}
              updateAlgorithmMap={this.updateAlgorithmMap}
              updateAlgorithmBasic={this.updateAlgorithmBasic}
            />

            <div style={{top: 4, left: 4, position: "absolute"}}>
              <ButtonGroup>
                <Button onClick={this.onSaveClick}>保存</Button>
                {/*<Button onClick={this.onClearClick}>清除</Button>*/}
                {/*<Button onClick={this.onCompileClick}>编译</Button>*/}
                <Button onClick={this.onRunClick}>运行</Button>
                <Button onClick={this.onBackClick}>返回</Button>
              </ButtonGroup>
            </div>

            <div style={{
              position: "absolute",
              top: this.state.clickY,
              left: this.state.clickX,
              zIndex: 4
            }}>
              <ContextMenu
                visible={this.state.contextMenuVisible}
                id={this.state.contextMenuClickId}
                item={this.state.algorithmMap[this.state.contextMenuClickId]}
                clone={clone}
                delete={this.deleteElement}
                copy={this.copyElement}
                cut={this.cutElement}
                paste={this.pasteElement}
                save={this.saveElement}
                run={this.runElement}
                output={this.getOutput(this.state.contextMenuClickId)}
              />
            </div>

            <div style={{
              position: "absolute",
              top: this.state.algorithmRunningStatusOffset.y,
              left: this.state.algorithmRunningStatusOffset.x,
              zIndex: 4
            }}>
              <ProjectPanelTooltip
                visible={this.state.algorithmRunningStatusVisible}
                info={this.state.algorithmMap[this.state.algorithmRunningStatusSelectId] ?
                  this.state.algorithmMap[this.state.algorithmRunningStatusSelectId].algorithmStatus :
                  null
                }
              />
            </div>

            <SaveModal
              visible={this.state.saveModalVisible}
              item={this.state.saveItem}
              clear={this.clearSaveElement}
              enterpriseId={this.props.enterpriseId}
              userId={this.props.userId}
              projectId={this.props.projectId}
              projectName={this.props.projectName}
            />
          </Col>

          {/*<Col span={4} style={{
            border: "1px solid rgba(0,0,0,.1)",
            height: 700
          }}>
            {
              this.renderDetails()
            }
          </Col>*/}

          <Drawer
            width={480}
            closable={true}
            visible={this.props.selectType === "dataset" || this.props.selectType === "model" || this.props.selectType === "algorithm"}
            onClose={this.onDrawerClose}
            zIndex={2}
          >
            {this.renderDetails()}
          </Drawer>
        </Row>
        {/*<div style={{marginTop: 8}}>
          <Button
            type="primary"
            style={{marginRight: 4}}
            onClick={this.onSaveClick}
          >
            保存
          </Button>
          <Button
            type="primary"
            style={{marginRight: 4}}
            onClick={this.onClearClick}
          >
            清除
          </Button>
          <Button
            type="primary"
            style={{marginRight: 4}}
            onClick={this.onLoadClick}>
            加载
          </Button>
          <Button
            type="primary"
            style={{marginRight: 4}}
            onClick={this.onCompileClick}>
            编译
          </Button>
          <Button
            type="primary"
            style={{marginRight: 4}}
            onClick={this.onRunClick}
          >
            运行
          </Button>
          <Button
            type="primary"
            onClick={this.onBackClick}
          >
            返回
          </Button>
        </div>*/}
        {/*<div className="html-joint-project-module-view">
          <div className="dataset-layout">
            <img src="http://localhost:8080/panda.png" className="icon" alt="logo" height="24" width="24"/>
            <label>kmeans聚类模型训练</label>
            </div>
          <div id="status" className="status-info success anticon anticon-check-circle"/>
        </div>*/}

        {/*<div className="html-joint-project-module-view">
          <div className="dataset-layout">
          </div>
        </div>*/}
      </Card>
    )
  }

  /**
   * Add event listeners to paper.
   */
  addPaperEventListeners() {
    const g = this.graph;
    const me = this;
    this.paper.on('cell:pointerclick',
      function (cellView, evt, x, y) {
        evt.stopPropagation();

        console.group("ProjectPanel cell click event");
        console.log("id:", cellView.model.id);
        console.log("module id:", cellView.model.attributes.elId);
        console.log("module type:", cellView.model.attributes.elType);
        console.log("cell:", cellView);
        console.groupEnd();


        me.graph.getElements().forEach(cell => {
          let cellView = me.paper.findViewByModel(cell);
          cellView.$box.find("label").css({
            color: "#000"
          })
        });

        cellView.$box.find("label").css({
          color: "#1890ff"
        });

        me.props.dispatch({
          type: "/projectPanel/SELECT_ID",
          nodeId: cellView.model.id,
          elId: cellView.model.attributes.elId,
          elType: cellView.model.attributes.elType
        });
        me.setState({
          clickX: 0,
          clickY: 0,
          contextMenuVisible: false,
          contextMenuClickId: "",
          algorithmRunningStatusVisible: false,
          algorithmRunningStatusOffset: {
            x: 0,
            y: 0
          },
        })
      }
    );

    this.paper.on('cell:contextmenu',
      function (cellView, evt, x, y) {
        evt.stopPropagation();

        console.group("ProjectPanel cell right click event");
        console.log("id:", cellView.model.id);
        console.log("coord-x:", x, "coord-y:", y);
        console.groupEnd();

        // if (cellView.model.attributes.elType === "algorithm") {
          me.setState({
            clickX: x, // + me.paper.clientOffset().x,
            clickY: y, // + me.paper.clientOffset().y,
            contextMenuVisible: true,
            contextMenuClickId: cellView.model.id,
            algorithmRunningStatusVisible: false,
            algorithmRunningStatusOffset: {
              x: 0,
              y: 0
            },
          })
        // }
      }
    );

    this.paper.on('blank:pointerclick',
      function (evt, x, y) {
        console.group("ProjectPanel blank click event");
        console.log("x:", x);
        console.log("y:", y);
        console.groupEnd("ProjectPanel blank click event");
        me.setState({
          clickX: 0,
          clickY: 0,
          contextMenuVisible: false,
          contextMenuClickId: "",
          algorithmRunningStatusVisible: false,
          algorithmRunningStatusOffset: {
            x: 0,
            y: 0
          }
        });
        me.props.dispatch({
          type: "/projectPanel/SELECT_ID",
          elId: "",
          selectId: "",
          selectType: ""
        });
        me.graph.getElements().forEach(cell => {
          let cellView = me.paper.findViewByModel(cell);
          cellView.$box.find("label").css({
            color: "#000"
          })
        });
      }
    );

    this.graph.on('change:source change:target',
      function (link) {
        link.attr({
          '.connection': {stroke: 'black'},
          '.marker-target': {fill: 'black', d: 'M 10 0 L 0 5 L 10 10 z'}
        });
        link.set('smooth', true);

        if(me.state.messageVisible) {
          console.log("connecting link", link);
          link.remove();
        }
      }
    );

    this.paper.on('blank:contextmenu',
      function (evt, x, y) {
        me.setState({
          clickX: x,
          clickY: y,
          contextMenuVisible: true,
          contextMenuClickId: "",
          algorithmRunningStatusVisible: false,
          algorithmRunningStatusOffset: {
            x: 0,
            y: 0
          },
        })
      }
    );

    this.paper.on("cell:mouseover",
      function(cellView, evt) {

        if (cellView.model.attributes.type === "link")
          return;

        console.group("Mouse over");
        console.log("cellView:", cellView);
        console.log("(x, y):",
          cellView.model.getBBox().x + cellView.model.getBBox().width,
          cellView.model.getBBox().y + cellView.model.getBBox().height / 2);
        console.groupEnd();

        me.setState({
          algorithmRunningStatusVisible: true,
          algorithmRunningStatusOffset: {
            x: cellView.model.getBBox().x + cellView.model.getBBox().width + 6,
            y: cellView.model.getBBox().y + cellView.model.getBBox().height / 2 - 17
          },
          algorithmRunningStatusSelectId: cellView.model.id
        })
      });

    this.paper.on("cell:mouseout",
      function(cellView, evt) {
        setTimeout(
          () => {
            me.setState({
              algorithmRunningStatusVisible: false,
              algorithmRunningStatusOffset: {
                x: 0,
                y: 0
              },
              algorithmRunningStatusSelectId: ""
            })
          }, 100
        );
      })

    // this.paper.on('blank:pointerdown',
    //   function (evt, x, y) {
    //     me.setState({
    //       clickX: 0,
    //       clickY: 0,
    //       contextMenuVisible: false,
    //       contextMenuClickId: "",
    //       dragStart: {
    //         x,
    //         y
    //       }
    //     })
    //   }
    // );
    //
    // this.paper.on("blank:pointerup", function(evt) {
    //   me.setState({
    //     dragStart: null
    //   })
    // });
    //
    // $("#diagram").mousemove(function(evt) {
    //   if (me.state.dragStart) {
    //     me.paper.translate(
    //       evt.offsetX - me.state.dragStart.x,
    //       evt.offsetY - me.state.dragStart.y
    //     )
    //     console.log("offset:", me.paper.translate());
    //   }
    // })
  }


  /**
   * Initialize page parameters.
   */
  initializeParameters() {
    this.setState({
      selfOffset: {
        x: this.paper.clientOffset().x,
        y: this.paper.clientOffset().y
      }
    });

    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      selectId: "",
      selectType: ""
    });
  }


  /**
   * Load the project based on whether the project is opened or created.
   */
  onLoadClick() {
    getData(`/api-bigdata/projects/${this.props.projectId}`).then(
      response => {

        // const json = JSON.parse(response.data.json);

        console.group(`ProjectPanel GET /api-bigdata/projects/${this.props.projectId}:`);
        // console.log("json:", json);
        console.log("data:", response.data);
        console.groupEnd();

        this.props.dispatch(updateProps({
          name: "projectName",
          value: response.data.name
        }));

        response.data.modules.forEach(module => this.loadModule(module))

        return getData(`/api-files/?name=${response.data.location}&category=json`);
      }
    ).then(
      response => {
        const json = response.data;
        console.log("json File:", json);
        this.graph.fromJSON(json);
      }
    ).catch(
      ex => {
        console.error(`ProjectPanel GET /api-bigdata/projects/${this.props.projectId} exception:`, ex);
      }
    )
  }


  loadModule(module) {
    switch(module.moduleType.code) {
      case "001":
        this.loadDataSet(module);
        break;
      case "002":
        this.loadAlgorithm(module);
        break;
      case "003":
        this.loadModel(module);
        break;
      default:
        break;
    }
  }


  loadDataSet(module) {
    getData(`/api-bigdata/datasets/${module.objectId}`).then(
      response => {
        let newDataSetMap = JSON.parse(JSON.stringify(this.state.dataSetMap));
        newDataSetMap[module.id] = response.data;
        this.setState({
          dataSetMap: newDataSetMap
        })
      }
    ).catch(
      ex => {
        console.error(`ProjectPanel GET /api-bigdata/datasets/${module.objectId} exception:`, ex);
      }
    );
  }


  loadAlgorithm(module) {
    let params = null;
    getData(`/api-algorithm/algorithmParameters/search/algorithmParameterInfo?algorithmId=${module.objectId}`).then(
      response => {
        params = response.data;
        let inputParams = params._embedded.algorithmParameters.filter(param => param.type === "MODEL_IN" || param.type === "DATASET_IN");
        let outputParams = params._embedded.algorithmParameters.filter(param => param.type === "MODEL_OUT" || param.type === "DATASET_OUT");
        let normalInputParams = params._embedded.algorithmParameters.filter(param => param.type !== "MODEL_IN" && param.type !== "DATASET_IN" && param.type !== "MODEL_OUT" && param.type !== "DATASET_OUT");

        // TODO: whether we need to load input/output params.
        module.inputParams.forEach(inputParam => {
          let tmp = normalInputParams.filter(normalInputParam => normalInputParam.name === inputParam.name)[0];
          if (tmp)
            tmp.value = inputParam.value
        });

        this.updateAlgorithmMap({
          nodeId: module.id,
          algorithmId: module.objectId,
          inputParams: inputParams,
          outputParams: outputParams,
          normalInputParams: normalInputParams
        });

        return getData(`/api-algorithm/algorithms/${module.objectId}?projection=exposeAllAlgorithmFields`)
      }
    ).then(
      response => {
        response.data.nodeId = module.id;
        this.updateAlgorithmBasic(response.data);
      }
    );
  }


  loadModel(module) {
    getData(`/api-bigdata/models/${module.objectId}`).then(
      response => {
        let newModelMap = JSON.parse(JSON.stringify(this.state.modelMap));
        newModelMap[module.id] = response.data;
        this.setState({
          modelMap: newModelMap
        })
      }
    ).catch(
      ex => {
        console.error(`/api-bigdata/models/${module.objectId} exception:`, ex);
      }
    );
  }


  /**
   * Check whether two node's ports can be connected.
   * @param requiredInputTypes
   * @param currentInputTypes
   * @param connectingType
   * @returns {boolean}
   */
  checkConnection(requiredInputTypes, currentInputTypes, connectingType) {
    requiredInputTypes = requiredInputTypes.map(requiredInputType => requiredInputType.split("_")[0].toLowerCase());
    currentInputTypes = currentInputTypes.map(currentInputType => currentInputType.split("_")[0].toLowerCase());
    connectingType = connectingType.toLowerCase();
    currentInputTypes.push(connectingType);
    requiredInputTypes.sort();
    currentInputTypes.sort();

    console.group("ProjectPanel checkConnection");
    console.log("requiredTypes:", requiredInputTypes);
    console.log("currentTypes:", currentInputTypes);
    console.log("connectingType:", connectingType);
    console.groupEnd();

    if (currentInputTypes.length > requiredInputTypes.length)
      return false;

    for(let i = 0; i < currentInputTypes.length; i++) {
      let index = requiredInputTypes.indexOf(currentInputTypes[i]);
      if (index === -1)
        return false;
      requiredInputTypes.splice(index, 1);
    }

    return true;
  }


  /**
   * Used for adding cell to graph.
   * @param module
   */
  addCell(module) {
    this.graph.addCell(module);
  }

  /**
   * Get jointjs paper offset x/y.
   * @returns {*}
   */
  getClientOffset() {
    return this.paper.clientOffset();
  }


  /**
   * Reset jointjs paper offset x/y due to mouse scroll.
   * @param offset
   */
  updateClientOffset(offset) {
    this.setState({
      selfOffset: {
        x: offset.x,
        y: offset.y
      }
    })
  }


  /**
   * Save project.
   */
  onSaveClick(showToolTip = true) {
    console.group("ProjectPanel onSaveClick");
    console.log("json:", this.graph.toJSON());
    console.log("algorithmMap:", this.state.algorithmMap);
    console.log("dataSetMap:", this.state.dataSetMap);
    console.log("modelMap:", this.state.modelMap);
    console.log("project id:", this.props.projectId);
    console.groupEnd();

    let loading = null;
    if (showToolTip) {
      loading = message.loading("工程保存中，请稍候...", 0);
    }

    this.graph.getElements().filter(ele => ele.attributes.elType === "algorithm").forEach(cell => {
      console.log("cell:", cell);
      cell.set("status", "status-info running anticon anticon-info-circle");
    });

    const json = this.graph.toJSON();
    let modules = [];
    const existModules = json.cells.filter(cell => cell.type === "html.Element").map(cell => cell.id);
    modules = modules
      .concat(this.saveAlgorithmModule(existModules))
      .concat(this.saveDataSetModule(existModules))
      .concat(this.saveModelModule(existModules));
    console.log("ProjectMenu onSaveClick modules:", modules);

    return this.saveProjectGraphFile(json).then(
      response => {
        console.log("ProjectPanel save graph file:", response.data);
        return response.data;
      }
    ).then(
      response => {
        return axios({
          url: `/api-bigdata/projects`,
          method: "POST",
          data: {
            id: (this.props.projectId && this.props.projectId !== "") ? this.props.projectId : null,
            userId: this.props.userId,
            location: response,
            modules: modules,
            name: this.props.projectName
          }
        })
      }
    ).then(
      response => {
        console.log("ProjectPanel create project object:", response.data);

        if (showToolTip) {
          message.destroy();
          message.config({
            top: 16,
            duration: 3
          });
          message.success(`工程${response.data.id}: 创建成功`);
            {/*<div style={{
            background: "#52c41a",
            color: "#ffffff",
            padding: 16
          }}>{
              `工程${response.data.id}: 创建成功`
            }</div>);*/}

          // notification.config({
          //   duration: 5,
          // });
          // notification.open({
          //   message: '工程创建成功',
          //   description: '工程创建成功',
          // });
        }
        this.props.dispatch(updateProps({
          name: "projectId",
          value: response.data.id
        }));
      }
    ).catch(
      ex => {
        console.error("ProjectPanel create project exception:", ex);
        message.destroy();
        message.config({
          top: 16,
          duration: 3
        });
        message.error(`工程创建失败`);
          {/*<div style={{
          background: "#f5222d",
          color: "#ffffff",
          padding: 16
        }}>{`工程创建失败`}</div>);*/}
      }
    )
  }


  removeNotExistModule(obj, existModules) {
    let keys = Object.keys(obj);
    keys.forEach(key => {
      if (existModules.indexOf(key) === -1) {
        delete obj[key]
      }
    });
    return obj;
  }


  saveAlgorithmModule(existModules) {
    const localAlgorithmMap = this.removeNotExistModule(this.state.algorithmMap, existModules);
    const algorithmNodeKeys = Object.keys(localAlgorithmMap);
    return algorithmNodeKeys.map(
      algorithmNodeKey => {
        const algorithmNode = localAlgorithmMap[algorithmNodeKey];
        let inputParams = algorithmNode.inputParams.concat(algorithmNode.normalInputParams);
        let outputParams = algorithmNode.outputParams;
        return {
          id: algorithmNodeKey,
          objectId: algorithmNode.algorithmId,
          name: algorithmNode.algorithmInfo.name,
          moduleRunningStatus: {
            code: "001"
          },
          moduleType: {
            code: "002"
          },
          inputParams: inputParams.map(param => ({
            inputParamType: {
              code: this.getInputParamTypeCode(param.type)
            },
            name: param.name,
            value: param.value
          })),
          outputParams: outputParams.map(param => ({
            outputParamType: {
              code: this.getOutputParamTypeCode(param.type)
            },
            name: param.name,
            value: param.value
          }))
        };
      }
    );
  }


  saveDataSetModule(existModules) {
    const localDataSetMap = this.removeNotExistModule(this.state.dataSetMap, existModules);
    const datasetNodeKeys = Object.keys(localDataSetMap);
    return datasetNodeKeys.map(
      datasetNodeKey => {
        let datasetNode = localDataSetMap[datasetNodeKey];
        return {
          id: datasetNodeKey,
          objectId: datasetNode.id,
          name: datasetNode.name,
          inputParams: [],
          outputParams:[{
            outputParamType: {
              code: this.getOutputParamTypeCode("dataset_out")
            },
            name: datasetNode.path,
            value: datasetNode.path
          }],
          moduleRunningStatus: null,
          moduleType: {
            code: "001"
          }
        };
      }
    );
  }


  saveModelModule(existModules) {
    const localModelMap = this.removeNotExistModule(this.state.modelMap, existModules);
    const modelNodeKeys = Object.keys(localModelMap);
    return modelNodeKeys.map(
      modelNodeKey => {
        let modelNode = localModelMap[modelNodeKey];
        return {
          id: modelNodeKey,
          objectId: modelNode.id,
          name: modelNode.name,
          inputParams: [],
          outputParams: [{
            outputParamType: {
              code: this.getOutputParamTypeCode("model_out")
            },
            name: modelNode.path,
            value: modelNode.path
          }],
          moduleRunningStatus: null,
          moduleType: {
            code: "003"
          }
        };
      }
    );
  }


  saveProjectGraphFile(json) {
    let headers = new Headers();
    headers.append("enctype", "multipart/form-data");
    let fileData = new FormData();
    fileData.append("file", new File([JSON.stringify(json)], "foo.json", {type: "text/json;charset=utf-8"}));
    fileData.append("category", "json");
    return axios({
      url: `/api-files/`,
      method: "POST",
      headers: headers,
      data: fileData
    });
  }


  /**
   * Clear the graph and reset the parameters.
   */
  onClearClick() {
    this.graph.clear();
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      elId: "",
      selectId: "",
      selectType: ""
    });
    this.setState({
      selfOffset: "",
      clickX: 0,
      clickY: 0,
      contextMenuVisible: false,
      contextMenuClickId: "",
      dataSetMap: {},
      algorithmMap: {},
      modelMap: {}
    });
  }


  /**
   * Compile project
   */
  onCompileClick() {
    return axios({
      url: `/api-bigdata/projects/${this.props.projectId}?enterpriseId=${this.props.enterpriseId}&userId=${this.props.userId}`,
      method: "POST",
      data:
        this.graph.toJSON()
          .cells.filter(cell => cell.type === "link")
          .map(cell => ({
              source: cell.source.id,
              sourcePort: cell.source.port,
              target: cell.target.id,
              targetPort: cell.target.port
          }))
    }).then(
      response => {
        console.log(`ProjectPanel compile success:`, response.data);
        return response
      }
    ).catch(
      ex => {
        console.error(`ProjectPanel compile exception:`, ex);
      }
    )
  }


  /**
   * Run project
   */
  onRunClick() {
    let compileResult = null;
    const loading = message.loading("算法运行中，请稍候...", 0);
    this.onSaveClick(false).then(
      response => {
        console.log("ProjectPanel onRunClick links:", this.graph.toJSON().cells.filter(cell => cell.type === "link"));
        return this.onCompileClick()
      }
    ).then(
      response => {
        console.log(`ProjectPanel compile success:`, response.data);
        if (response.data) {
          compileResult = response.data;
          let counter = 0;
          this.graph.bfs(this.graph.getCell(compileResult[0]), (element, distance) => counter++);
          console.log("ProjectPanel onRunClick counter:", counter, "cells:", this.graph.getCells());
          if (counter !== this.graph.getCells().filter(cell => cell.attributes.type !== "link").length) {
            throw new Error("modules are not connected");
          }
          return this.cleanProject();
        } else {
          throw new Error("project parameters are not correct.");
        }
      }
    ).then(
      cleanResponse => {
        if (cleanResponse.data === "ok") {

          this.saveRunStatus(compileResult);

          let funcs = compileResult
            .filter(module => module.moduleType.code === "002")
            .map(module => ({
              id: module.id,
              execution: () => {
                let name = `${this.state.algorithmMap[module.id].algorithmInfo.algorithmFileId}`;
                let tenant = "fakeTenantName";
                let mode = this.state.algorithmMap[module.id].algorithmInfo.algorithmType.name;
                console.group("Execution");
                console.log("name:", name);
                console.log("mode:", mode);
                console.log("project:", this.props.projectName);
                console.groupEnd();
                return axios({
                  url: `/api-bigdata/projectExecution/${this.props.projectId}?name=${name}&tenant=${tenant}&mode=${mode}`,
                  method: "POST",
                  data: module
                })
              }
            }));

          this.promiseSerial(funcs).then(
            response => {
              console.log("ProjectPanel execution success", response.data);
              message.destroy();
              message.config({
                top: 16,
                duration: 3
              });
              message.success(`项目执行成功`);
                {/*<div style={{
                background: "#52c41a",
                color: "#ffffff",
                padding: 16
              }}>{`项目执行成功`}</div>);*/}
            }
          ).catch(
            ex => {
              console.error("ProjectPanel execution failed", ex);
              message.destroy();
              message.config({
                top: 16,
                duration: 3
              });
              message.error(`项目执行失败`);
                {/*<div style={{
                background: "#f5222d",
                color: "#ffffff",
                padding: 16
              }}>{`项目执行失败`}</div>);*/}
            }
          )
        } else {

        }
      }
    ).catch(
      ex => {
        console.error(`ProjectPanel run exception:`, ex);
        message.destroy();
        message.config({
          top: 16,
          duration: 3
        });
        message.error(`工程校验失败，请检查连接设置`);
          {/*<div style={{
          background: "#f5222d",
          color: "#ffffff",
          padding: 16
        }}>{`工程校验失败，请检查连接设置`}</div>);*/}
      }
    )
  }


  saveRunStatus(modules) {
    modules.forEach(module => {
      this.graph.getCell(module.id).set("status", "");
      if (module.moduleType.code === "002") {
        let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
        for(let i = 0; i < newAlgorithmMap[module.id].inputParams.length; i++) {
          newAlgorithmMap[module.id].inputParams[i].value = module.inputParams[i].value;
        }
        for(let i = 0; i < newAlgorithmMap[module.id].outputParams.length; i++) {
          newAlgorithmMap[module.id].outputParams[i].value = module.outputParams[i].value;
        }
        this.setState({
          algorithmMap: newAlgorithmMap
        })
      }
    });
  }

  cleanProject() {
    return axios({
      url: `/api-bigdata/cleanProject?enterpriseId=${this.props.enterpriseId}&userId=${this.props.userId}&projectId=${this.props.projectId}`,
      method: "DELETE"
    })
  }


  /**
   * Helper function which helps onRunClick function to execute the module one by one.
   * @param funcs
   * @returns {*}
   */
  promiseSerial(funcs) {
    return funcs.reduce((promise, func) => {
      return promise.then(
        response => {
          this.graph.getCell(func.id).set("status", "anticon anticon-spin anticon-loading");
          return func.execution().then(
            response => {
              console.log("ProjectPanel promiseSerial response:", response.data);
              if (response.data === "ok") {
                this.graph.getCell(func.id).set("status", "status-info success anticon anticon-check-circle");
                let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
                newAlgorithmMap[func.id].algorithmStatus = response.data;
                this.setState({
                  algorithmMap: newAlgorithmMap
                });
              } else {
                this.graph.getCell(func.id).set("status", "status-info fail anticon anticon-close-circle");
                throw new Error("Execution failed");
              }
              return response;
            }
          ).catch(
            ex => {
              console.log("ProjectPanel promiseSerial exception:", ex);
              this.graph.getCell(func.id).set("status", "status-info fail anticon anticon-close-circle");
              let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
              newAlgorithmMap[func.id].algorithmStatus = ex.data;
              this.setState({
                algorithmMap: newAlgorithmMap
              });

              throw new Error("Execution failed");
            }
          )
        }
      )
    }, Promise.resolve([]));
  }


  /**
   * Back button handler
   */
  onBackClick() {
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      selectId: "",
      selectType: ""
    });

    this.props.history.push("/console/bigdata/projectList");
  }


  /**
   * Render the sidebar module details.
   * @returns {*}
   */
  renderDetails() {
    console.debug("ProjectPanel renderDetail selectType:", this.props.selectType);
    switch(this.props.selectType) {
      case "dataset":
        return <DataSetDetail dataSetMap={this.state.dataSetMap}/>;
      case "model":
        return <ModelDetail modelMap={this.state.modelMap}/>;
      case "algorithm":
        return <AlgorithmDetail algorithmMap={this.state.algorithmMap} updateAlgorithmParam={this.updateAlgorithmParam}/>;
      default:
        return null;
    }
  }


  /**
   * Update dataset map data structure.
   * @param data
   */
  updateDataSetMap(data) {
    if (this.state.dataSetMap[data.nodeId] !== undefined &&
      this.state.dataSetMap[data.nodeId] !== null &&
      this.state.dataSetMap[data.nodeId] !== "") {
      // this shouldn't happen.
    } else {
      console.log("ProjectPanel updateDataSetMap:", data);
      let newDataSetMap = JSON.parse(JSON.stringify(this.state.dataSetMap));
      data.children = [];
      data.output = "";
      newDataSetMap[data.nodeId] = data;
      this.setState({
        dataSetMap: newDataSetMap
      });
    }
  }


  /**
   * Update model map data structure.
   * @param data
   */
  updateModelMap(data) {
    if (this.state.modelMap[data.nodeId] !== undefined &&
      this.state.modelMap[data.nodeId] !== null &&
      this.state.modelMap[data.nodeId] !== "") {
      // this shouldn't happen.
    } else {
      let newModelMap = JSON.parse(JSON.stringify(this.state.modelMap));
      data.children = [];
      data.output = "";
      newModelMap[data.nodeId] = data;

      this.setState({
        modelMap: newModelMap
      });
    }
  }


  /**
   * Update algorithm map data structure.
   * @param data
   */
  updateAlgorithmMap(data) {
    console.log("ProjectPanel updateAlgorithmMap:", data);
    let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
    if (newAlgorithmMap[data.nodeId] !== undefined &&
      newAlgorithmMap[data.nodeId] !== null &&
      newAlgorithmMap[data.nodeId] !== "") {
      // 1. we have already visit this node, this should not happen.
    } else {
      // 2. otherwise, this is the first time we visit this node.
      newAlgorithmMap[data.nodeId] = {
        algorithmId: "",
        inputParams: [],
        outputParams: [],
        normalInputParams: [],
        algorithmInfo: {},
        children: []
      };
      newAlgorithmMap[data.nodeId].algorithmId = data.algorithmId;
      newAlgorithmMap[data.nodeId].inputParams = data.inputParams.map(algorithmParam => {
        if (algorithmParam.value === undefined || algorithmParam === null)
          algorithmParam.value = "";
        return algorithmParam;
      });
      newAlgorithmMap[data.nodeId].outputParams = data.outputParams.map(algorithmParam => {
        if (algorithmParam.value === undefined || algorithmParam === null)
          algorithmParam.value = "";
        return algorithmParam;
      });
      newAlgorithmMap[data.nodeId].normalInputParams = data.normalInputParams.map(algorithmParam => {
        if (algorithmParam.value === undefined || algorithmParam === null)
          algorithmParam.value = algorithmParam.defaultValue;
        return algorithmParam;
      });
      this.setState({
        algorithmMap: newAlgorithmMap
      })
    }
  }


  /**
   * Update algorithm basic information.
   * @param data
   */
  updateAlgorithmBasic(data) {
    console.log("ProjectPanel updateAlgorithmBasic:", data);
    let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
    if (newAlgorithmMap[data.nodeId] !== undefined &&
      // 1. we have already visit this node
      newAlgorithmMap[data.nodeId] !== null &&
      newAlgorithmMap[data.nodeId] !== "") {
      newAlgorithmMap[data.nodeId].algorithmInfo = data;
      this.setState({
        algorithmMap: newAlgorithmMap
      })
    } else {
      // this should never happen
    }
  }


  /**
   * Update algorithm parameter list.
   * @param data
   */
  updateAlgorithmParam(data) {
    console.log("ProjectPanel updateAlgorithmParam:", data);
    let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
    if (newAlgorithmMap[data.nodeId] !== undefined &&
      // 1. we have already visit this node
      newAlgorithmMap[data.nodeId] !== null &&
      newAlgorithmMap[data.nodeId] !== "") {
      this.graph.getCell(this.props.nodeId).set("status", "status-info warning anticon anticon-exclamation-circle");
      let newInputParams = newAlgorithmMap[data.nodeId].inputParams.slice(0);
      newInputParams.map(param => {
        if (param.name === data.name) {
          param.value = data.value;
        }
        return param;
      });
      newAlgorithmMap[data.nodeId].inputParams = newInputParams;

      let newOutputParams = newAlgorithmMap[data.nodeId].outputParams.slice(0);
      newOutputParams.map(param => {
        if (param.name === data.name) {
          param.value = data.value;
        }
        return param;
      });
      newAlgorithmMap[data.nodeId].outputParams = newOutputParams;

      let newNormalInputParams = newAlgorithmMap[data.nodeId].normalInputParams.slice(0);
      newNormalInputParams.map(param => {
        if (param.name === data.name) {
          param.value = data.value;
        }
        return param;
      });
      newAlgorithmMap[data.nodeId].normalInputParams = newNormalInputParams;
      this.setState({
        algorithmMap: newAlgorithmMap
      })
    } else {
      // this should never happen
    }
  }


  /**
   * Convert input param type to code.
   * @param type
   * @returns {string}
   */
  getInputParamTypeCode(type) {
    const caseType = type.toLowerCase();
    switch (caseType) {
      case "dataset_in":
        return "001";
      case "model_in":
        return "002";
      case "integer":
        return "003";
      case "decimal":
        return "004";
      case "string":
        return "005";
      case "enum":
        return "006";
      case "boolean":
        return "007";
      default:
        return "000";
    }
  }


  /**
   * Convert output param type to code.
   * @param type
   * @returns {string}
   */
  getOutputParamTypeCode(type) {
    const caseType = type.toLowerCase();
    switch (caseType) {
      case "dataset_out":
        return "001";
      case "model_out":
        return "002";
      default:
        return "000";
    }
  }


  /**
   * Delete operation in context menu
   * @param id
   */
  deleteElement(id) {
    this.graph.getCell(id).remove();
    this.deleteElementHelper(id);
    this.setState({
      contextMenuVisible: false,
      contextMenuClickId: ""
    });
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      elId: "",
      elType: ""
    })
  }


  /**
   * Helper function for delete.
   * @param id
   */
  deleteElementHelper(id) {
    if (this.state.algorithmMap[id]) {
      let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
      delete newAlgorithmMap[id];
      this.setState({
        algorithmMap: newAlgorithmMap
      });
    } else if (this.state.dataSetMap[id]) {
      let newDataSetMap = JSON.parse(JSON.stringify(this.state.dataSetMap));
      delete newDataSetMap[id];
      this.setState({
        dataSetMap: newDataSetMap
      });
    } else if (this.state.modelMap[id]) {
      let newModelMap = JSON.parse(JSON.stringify(this.state.modelMap));
      delete newModelMap[id];
      this.setState({
        modelMap: newModelMap
      })
    }
  }


  /**
   * Copy operation in context menu
   * @param id
   */
  copyElement(id) {
    clone = this.graph.getCell(id).clone();
    origin = null;
    originType = null;
    if (this.state.algorithmMap[id]) {
      origin = this.state.algorithmMap[id];
      originType = "algorithm";
    } else if (this.state.dataSetMap[id]) {
      origin = this.state.dataSetMap[id];
      originType = "dataset";
    } else if (this.state.modelMap[id]) {
      origin = this.state.modelMap[id];
      originType = "model";
    }
    this.setState({
      contextMenuVisible: false,
      contextMenuClickId: ""
    });
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      elId: "",
      elType: ""
    })
  }


  /**
   * Cut operation in context menu
   * @param id
   */
  cutElement(id) {
    clone = this.graph.getCell(id).clone();
    origin = null;
    originType = null;
    if (this.state.algorithmMap[id]) {
      origin = this.state.algorithmMap[id];
      originType = "algorithm";
    } else if (this.state.dataSetMap[id]) {
      origin = this.state.dataSetMap[id];
      originType = "dataset";
    } else if (this.state.modelMap[id]) {
      origin = this.state.modelMap[id];
      originType = "model";
    }

    this.deleteElementHelper(id);
    this.graph.getCell(id).remove();
    this.setState({
      contextMenuVisible: false,
      contextMenuClickId: ""
    });
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      elId: "",
      elType: ""
    })
  }


  /**
   * Paste operation in context menu
   * @param id
   */
  pasteElement(id) {
    console.log("ProjectPanel pasteElement:", this.state.clickX, this.state.clickY);
    clone.position(this.state.clickX, this.state.clickY);
    this.graph.addCell(clone);

    switch(originType){
      case "algorithm": {
        let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
        newAlgorithmMap[clone.id] = origin;
        this.setState({
          algorithmMap: newAlgorithmMap
        });
        break;
      }
      case "dataset": {
        let newDataSetMap = JSON.parse(JSON.stringify(this.state.dataSetMap));
        newDataSetMap[clone.id] = origin;
        this.setState({
          dataSetMap: newDataSetMap
        });
        break;
      }
      case "model": {
        let newModelMap = JSON.parse(JSON.stringify(this.state.modelMap));
        newModelMap[clone.id] = origin;
        this.setState({
          modelMap: newModelMap
        });
        break;
      }
      default:
        break;
    }

    clone = null;
    originType = null;
    origin = null;
    this.setState({
      contextMenuVisible: false,
      contextMenuClickId: ""
    });
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: "",
      elId: "",
      elType: ""
    })
  }


  /**
   * Save operation in context menu
   * @param id
   */
  saveElement(id, paramIndex) {
    console.log("ProjectPanel saveElement algorithmMap:", this.state.algorithmMap[id], paramIndex);
    // TODO: call model save or dataset save
    this.setState({
      contextMenuVisible: false,
      saveModalVisible: true,
      saveItem: this.state.algorithmMap[id].outputParams[paramIndex],
      projectId: this.props.projectId
    })
  }

  clearSaveElement() {
    this.setState({
      saveModalVisible: false,
      saveItem: null
    })
  }


  /**
   * Run operation in context menu
   * @param id
   */
  runElement(id) {
    let cell = this.graph.getCell(id);
    let elements = [];
    this.graph.bfs(cell, (element, distance) => {
      // let links = this.graph.getConnectedLinks(element, {outbound: true});
      elements.push(element)
      // elements = elements.concat(links);
    }, {outbound: true});
    console.log("ProjectPanel runElement subGraph:", elements);

    // let links = elements.filter(element => element.attributes.type === "link")
    //   .map(cell =>
    //     ({
    //       source: cell.attributes.source.id,
    //       sourcePort: cell.attributes.source.port,
    //       target: cell.attributes.target.id,q
    //       targetPort: cell.attributes.target.port
    //     }));

    let links = this.graph.getCells()
      .filter(cell => cell.attributes.type === "link")
      .map(cell =>
        ({
          source: cell.attributes.source.id,
          sourcePort: cell.attributes.source.port,
          target: cell.attributes.target.id,
          targetPort: cell.attributes.target.port
        }));

    console.log("ProjectPanel runElement links:", links);
    axios({
      url: `/api-bigdata/projects/${this.props.projectId}?enterpriseId=${this.props.enterpriseId}&userId=${this.props.userId}`,
      method: "POST",
      data: links
    }).then(
      response => {
        if (response.data) {
          let counter = 0;
          this.graph.bfs(this.graph.getCell(response.data[0]), (element, distance) => counter++);
          console.log("ProjectPanel runElement counter:", counter, "cells:", this.graph.getCells());
          if (counter !== this.graph.getCells().filter(cell => cell.attributes.type !== "link").length) {
            throw new Error("modules are not connected");
          }
          response.data.forEach(module => {
            this.graph.getCell(module.id).set("status", "");
            if (module.moduleType.code === "002") {
              let newAlgorithmMap = JSON.parse(JSON.stringify(this.state.algorithmMap));
              for(let i = 0; i < newAlgorithmMap[module.id].outputParams.length; i++) {
                newAlgorithmMap[module.id].outputParams[i].value = module.outputParams[i].value;
              }
              this.setState({
                algorithmMap: newAlgorithmMap
              })
            }
          });

          let executionOrder = response.data.filter(d => elements.filter(e => e.id === d.id).length !== 0)
          console.log("ProjectPanel runElement run subgraph:", executionOrder);
          let funcs = executionOrder.filter(module => module.moduleType.code === "002").map(module => ({
            id: module.id,
            execution: () => {
              let name = `${this.state.algorithmMap[module.id].algorithmInfo.algorithmFileId}`;
              let tenant = "fakeTenantName";
              let mode = this.state.algorithmMap[module.id].algorithmInfo.algorithmType.name;
              console.group("Execution");
              console.log("name:", name);
              console.log("mode:", mode);
              console.log("project:", this.props.projectName);
              console.groupEnd();
              return axios({
                url: `/api-bigdata/projectExecution/${this.props.projectId}?name=${name}&tenant=${tenant}&mode=${mode}`,
                // url: `/api-bigdata/projectExecution`,
                method: "POST",
                data: module
              })
            }
          }));

          this.promiseSerial(funcs).then(
            response => {
              console.log("ProjectPanel runElement execution success", response.data);
              message.config({
                top: 16,
                duration: 3
              });
              message.success("项目执行成功");
            }
          ).catch(
            ex => {
              console.error("ProjectPanel runElement execution failed", ex);
              message.config({
                top: 16,
                duration: 3
              });
              message.error("项目执行失败");
            }
          )
        } else {
          throw new Error("project parameters are not correct.");
        }
      }
    ).catch(
      ex => {
        console.error(`ProjectPanel runElement POST/api-bigdata/projects/${this.props.projectId} exception:`, ex);
        message.config({
          top: 16,
          duration: 3
        });
        message.error("项目执行失败，请检查连接");
      }
    );

    this.setState({
      contextMenuVisible: false
    })
  }


  /**
   * Used for render context menu
   * @param id
   * @returns {*}
   */
  getOutput(id) {
    if (this.state.algorithmMap[id]) {
      return this.state.algorithmMap[id].outputParams.map(output => ({
        id: output.id,
        name: output.name,
        type: output.type,
        value: output.value
      }));
    } else if (this.state.dataSetMap[id]) {
      return [{
        id: this.state.dataSetMap[id].id,
        name: this.state.dataSetMap[id].name,
        type: "dataset",
        value: this.state.dataSetMap[id].path
      }];
    } else if (this.state.modelMap[id]) {
      return [{
        id: this.state.modelMap[id].id,
        name: this.state.modelMap[id].name,
        type: "model",
        value: this.state.modelMap[id].path
      }];
    }
  }

  onDrawerClose() {
    this.props.dispatch({
      type: "/projectPanel/SELECT_ID",
      nodeId: null,
      elId: null,
      elType: null
    });

    this.graph.getElements().forEach(cell => {
      let cellView = this.paper.findViewByModel(cell);
      cellView.$box.find("label").css({
        color: "#000"
      })
    });
  }

}

export const projectPanel = (state = {
  selectId: "",
  selectType: "",
  nodeId: ""
}, action) => {
  switch (action.type) {
    case "/projectPanel/SELECT_ID": {
      return {
        ...state,
        nodeId: action.nodeId,
        selectId: action.elId,
        selectType: action.elType
      };
    }
    default:
      return state;
  }
};

export const mapStateToProps = (state) => {
  return {
    selectId: state.projectPanel.selectId,
    selectType: state.projectPanel.selectType,
    nodeId: state.projectPanel.nodeId,
    projectName: state.projectList.projectName,
    projectId: state.projectList.projectId,
    userId: state.authentication.userId || "userId",
    enterpriseId: state.userData.enterprises[state.userData.currentEnterprise].id
  }
};

export const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
};

export default DragDropContext(HTML5Backend)(connect(mapStateToProps, mapDispatchToProps)(ProjectPanel));
